<template>
  <div class="printerset">
    <div>
      {{store}}
      <EditBtn :style="{marginLeft: 'auto', width: '25px', height: '25px'}" v-if="!edit" @click="editfn"/>
    </div>
    <div>
      <template v-if="edit">
        <label class="checkboxqwe" :class="value[i-1] ? 'selected' : ''" :key="i" v-for="i in 4" :for="`sticker-${store}-${i}`">
          <input type="checkbox" :name="`sticker-${store}-${i}`" :id="`sticker-${store}-${i}`" :checked="value[i-1]" @change="value[i-1]=$event.target.checked">標籤機{{i}} : {{storeInfo[`sticker_${i}`]?.name}}</label>
      </template>
      <template v-else>
        <label class="checkboxqwe" :class="stickers[i-1].includes(id) ? 'selected' : ''" :key="i" v-for="i in 4" :for="`sticker-${i}`">
          <input :disabled="true" type="checkbox" :name="`sticker-${i}`" :id="`sticker-${i}`" :checked="stickers[i-1].includes(id)"
          @change="updateValue(i, id, !stickers[i-1].includes(id))" :value="i">標籤機{{i}} : {{storeInfo[`sticker_${i}`]?.name}}</label>
      </template>
       <BtnsS v-if="edit" @save="updateValue" @cancel="edit=false" :style="{marginTop: '15px'}"/>
    </div>
  </div>
</template>

<script>
import EditBtn from '../../../../components/btn/editConvert.vue'
import { deleteapi, putapi } from '../../../../store/fetch'
export default {
  props: ['store', 'id', 'areas'],
  components: { EditBtn },
  data () {
    return {
      edit: false,
      value: [false, false, false, false]
    }
  },
  computed: {
    storeInfo () {
      return this.$store.getters.getInfo(this.store)
    },
    stickers () {
      return Array(4).fill('1').map((e, i) => {
        return this.storeInfo[`sticker_list_${i + 1}`] || []
      })
    },
    stickersN () {
      return Array(4).fill('1').map((e, i) => {
        return this.storeInfo[`sticker_${i + 1}`] || null
      })
    },
    stickersV () {
      return Array(4).fill('1').map((e, i) => {
        return !!(this.storeInfo[`sticker_list_${i + 1}`] || []).includes(this.id)
      })
    }
  },
  methods: {
    editfn () {
      Array(4).fill('1').map((e, i) => {
        this.value[i] = (this.storeInfo[`sticker_list_${i + 1}`] || []).includes(this.id)
      })
      this.edit = true
    },
    async updateValue () {
      await Promise.all(Array(4).fill('1').map(async (e, i) => {
        if (this.value[i] !== this.stickersV[i]) {
          console.log(this.store, this.id, this.value[i])
          if (this.value[i]) {
            const r = await putapi(`restaurantSetting/${this.store}/add/${i + 1}/${this.id}`)
            if (r) {
              this.storeInfo[`sticker_list_${i + 1}`] = r
            }
          } else {
            const r = await deleteapi(`restaurantSetting/${this.store}/remove/${i + 1}/${this.id}`)
            if (r) {
              this.storeInfo[`sticker_list_${i + 1}`] = r
            }
          }
        }
      })).then(() => {
        this.edit = false
      })
    }
  }

}
</script>

<style lang="scss" scoped>
.printerset {
  border: 1px solid var(--color-pri);
  width: 464px;
  height: fit-content;
  flex-shrink: 0;
  border-radius: 10px;
  &>div:nth-child(1){
    display: flex;
    width: 464px;
    height: 45px;
    padding: 10px 20px 10px 30px;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
    color: #FFFFFF;
    background-color: var(--color-pri);
    border-radius: 10px 10px 0 0;
    font-feature-settings: 'clig' off, 'liga' off;
    font-family: Noto Sans TC;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 15px; /* 75% */
    letter-spacing: 2px;
  }
  &>div:nth-child(2){
    border-radius: 0 0 10px 10px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 5px;
  }
}

label.checkboxqwe {
  display: flex;
  width: 410px;
  height: 45px;
  padding: 10px;
  align-items: center;
  gap: 10px;
  min-width: 180px;
  white-space: nowrap;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  font-weight: 400;
  font-size: 20px;
  line-height: 150%;
  letter-spacing: 0.05em;
  color: var(--color-checked);
  input[type=checkbox] {
    width: 30px;
    height: 30px;
    display: inline-block;
    border: 1px solid var(--color-checked);
    appearance: none;
    border-radius: 5px;
    &:checked {
      background-image: url(/svg/checkbox/checkmark.svg);
      background-position: center;
      background-size: 26px;
      background-repeat: no-repeat;
      background-color: var(--color-checked);
    }
  }
}
</style>
